export default __webpack_public_path__ + "static/media/Recreation.2fec6e07.svg";